import { render, staticRenderFns } from "./status-sidebar.vue?vue&type=template&id=65765e74&"
import script from "./status-sidebar.vue?vue&type=script&lang=js&"
export * from "./status-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports